import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// Inicializar Sentry antes do bootstrap do Angular
Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.sentry.release,

    // Configurações de contexto
    sendDefaultPii: true,

    // Integrações
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            // Session replay para debugging
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],

    // Performance monitoring
    tracesSampleRate: environment.sentry.tracesSampleRate,

    // Session replay
    replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: 1.0, // Sempre capturar replay quando há erro

    // Logs
    enableLogs: true,

    // Configurações específicas do projeto
    beforeSend(event) {
        // Filtrar dados sensíveis se necessário
        if (event.exception) {
            const error = event.exception.values?.[0];
            if (
                error?.value?.includes("senha") ||
                error?.value?.includes("password")
            ) {
                return null; // Não enviar erros que possam conter senhas
            }
        }
        return event;
    },

    // Tags globais
    initialScope: {
        tags: {
            component: "frontend-prosper",
            version: environment.version,
            environment: environment.sentry.environment,
        },
    },
});

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => {
        console.error(err);
        Sentry.captureException(err); // Capturar erros de bootstrap
    });
